module.exports = __webpack_public_path__ + "img/zy-title6.32b4cd78.png";